import Player from '@vimeo/player';
import vars from '../global/vars';

const initOverlay = (triggers) => {
    const { body } = vars;
    const overlay = document.querySelector('.js-overlay');
    const iframe = overlay.querySelector('.js-overlay-iframe');
    const titleTarget = overlay.querySelector('.js-title-target');
    const clientTarget = overlay.querySelector('.js-client-target');
    const cta = overlay.querySelector('.js-overlay-cta');
    const ctaText = overlay.querySelector('.js-overlay-cta-text');
    let overlayActive = false;
    let player;

    const initVideo = async () => {
        player = new Player(iframe);
        await player.play();
    };

    const toggleOverlay = (trigger) => {
        overlayActive = !overlayActive;
        if (overlayActive) {
            const { src, link, title, client, text } = trigger.dataset;
            iframe.src = `https://player.vimeo.com/video/${src}?autoplay=0&title=0&byline=0&portrait=0`;
            titleTarget.innerText = title;
            clientTarget.innerText = client;
            if (!link) {
                overlay.classList.add('no-cta');
            } else {
                cta.href = link;
                ctaText.innerText = text || 'Find out more';
            }
            initVideo();
        } else {
            iframe.src = '';
            titleTarget.innerText = '';
            clientTarget.innerText = '';
            cta.href = '';
            ctaText.innerText = '';
        }

        body.classList.toggle('overlay-active');
    };

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
            toggleOverlay(trigger);
        });
    });
};

export default initOverlay;
